import { FETCH_NETWORK_MEMBER } from 'src/graphql/user/network-member'
import useApolloQuery from 'src/hooks/useApolloQuery'
import { useNetworkName } from './use-network-name'

export default function useNetworkMember() {
  const networkName = useNetworkName()
  return useApolloQuery(FETCH_NETWORK_MEMBER, {
    variables: {
      networkName: networkName as string
    }
  })
}
